module.exports = __webpack_public_path__ + "img/mirror24.3aac3506.jpg";